/* eslint-disable camelcase */
import { type UseMutationResult, useMutation } from 'react-query';
import {
  PsuAwardService,
  RsuAwardService,
  // type Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBulkUpdateResponseDto,
  type Wealthlane_AwardService_Dtos_BulkImport_RsuAwardImportResponseDto,
} from '../../services/wealthlane-award-services';
import {
  ParticipantService,
  type Wealthlane_CustomerService_Dtos_Participant_ImportParticipantResponseDto,
} from '../../services/wealthlane-customer-services';

const usePutFileImport = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setImportedData: any,
  requestedModule: string
): UseMutationResult<
  | Wealthlane_CustomerService_Dtos_Participant_ImportParticipantResponseDto
  | Wealthlane_AwardService_Dtos_BulkImport_RsuAwardImportResponseDto
  // | Wealthlane_AwardService_Dtos_OptionAward_OptionAwardBulkUpdateResponseDto
  | undefined,
  unknown,
  any,
  unknown
> => {
  return useMutation(
    async (payload: any) => {
      if (requestedModule.includes('RSU')) {
        return await handleRequest(
          RsuAwardService.postApiAwardApiAppRSUAwardValidateBulkRSu(payload)
        );
      } else if (requestedModule.includes('PSU')) {
        return await handleRequest(
          PsuAwardService.postApiAwardApiAppPSUAwardValidateBulkPSu(payload)
        );
      }
      // else if (requestedModule.includes('Option')) {
      //   return await handleRequest(
      //     OptionAwardService.postApiAwardApiAppOptionAwardOptionAwardsBulkUpdate(payload)
      //   );
      // }
      // else {
      //   return await handleRequest(
      //     ParticipantService.postApiCustomerApiAppParticipantImportParticipants(payload)
      //   );
      // }
    },
    {
      onSuccess: (response) => {
        if (response != null) {
          setImportedData(response);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePutFileImport;
